import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { EcontentServicesService } from '../../inputfileds/form_services/econtent-services/econtent-services.service';
import { Inputfiledsbase } from '../../inputfileds/models/inputfiledsbase';
import { Observable } from 'rxjs';
import { QuestionControlService } from '../../inputfileds/form_services/question-control.service';
import { Router } from '@angular/router';
import { EContentFormComponent } from '../econtent/e-content-form/e-content-form.component';
import { ApiservicesService } from '../../Services/Apis/apiservices.service';

export interface PeriodicElement {
  id: number;
  courses: string;
  last_update: string;
}

interface EContentApiResponse {
  success: boolean;
  data: PeriodicElement[];
}

@Component({
    selector: 'app-econtent',
    imports: [
        MatIconModule,
        MatButtonModule,
        MatTableModule,
        CommonModule,
        MatMenuModule,
        MatFormFieldModule,
        EContentFormComponent,
        MatCardModule,
    ],
    templateUrl: './econtent.component.html',
    styleUrls: ['./econtent.component.scss'],
    providers: [QuestionControlService]
})
export class EcontentComponent {
  displayedColumns: string[] = ['courses', 'last_update', 'actions'];
  questions: Inputfiledsbase<string>[] | null = [];
  questions$: Observable<Inputfiledsbase<any>[]> | null;
  form!: FormGroup;

  ELEMENT_DATA: PeriodicElement[] = [];

  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  showForm = false;

  constructor(
    private eContentFormQuestions: EcontentServicesService,
    private qcs: QuestionControlService,
    private router: Router,
    private apiServices: ApiservicesService
  ) {
    this.questions$ = this.eContentFormQuestions.getecontentform();
    this.questions$.subscribe((questions) => {
      this.questions = questions;
      this.form = this.qcs.toFormGroup(
        this.questions as Inputfiledsbase<string>[]
      );
    });
  }

  get hasData(): boolean {
    return this.dataSource.data.length > 0;
  }
  getEContentCoursesData() {
    this.apiServices
      .getEContentCoursesList()
      .subscribe((response: EContentApiResponse) => {
        this.ELEMENT_DATA = response.data;
        this.dataSource = new MatTableDataSource<PeriodicElement>(
          response.data
        );
      });
  }

  deleteEContentCoursesData(id: number) {
    this.apiServices.deleteEContentCourseData(id).subscribe(
      () => {
        this.getEContentCoursesData();
      },
      (error) => {
        console.error('Error deleting activity:', error);
        alert('Failed to delete activity. Please try again later.');
      }
    );
  }

  ngOnInit() {
    this.getEContentCoursesData();
  }

  viewESemisterData(id: number) {
    this.router.navigate([`e-content/${id}/econtent-semisters`]);
  }

  createEcontentData() {
    this.showForm = true;
  }

  onFormSubmit(form_data: any) {
    // Check if it's FormData and has at least one key
    if (!(form_data instanceof FormData)) {
      console.warn('Form data is empty or invalid. Skipping submission.');
      return;
    }

    this.apiServices.createEContentData(form_data).subscribe({
      next: (res) => {
        this.form.reset();
        this.getEContentCoursesData(); // Refresh course list
        this.showForm = false; // Hide form
      },
      error: (err) => {
        console.error('Form submission failed:', err);
        // Add toast/snackbar if needed
      },
    });
  }

  onFormCancel() {
    this.showForm = false;
  }
}
